import { connect } from 'react-redux';
import { GetApprovedClients, GetClientInfo, SearchApprovedClients } from '../actions';
import ApprovedClients from './ApprovedClients';

const mapStateToProps = (state) => {
	return {
		user: state.auth.user,
		clients: state.client.clients,
		recordCount: state.client.count,
		showEditModal: state.client.showEditModal,
		isMaster: state.auth.isMaster,
		userRoles: state.auth.roles,
		search: state.client.searchApproved,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		getClients: (page, pageSize) => {
			return dispatch(GetApprovedClients(page, pageSize));
		},
		searchClients: (search, page, pageSize, order, orderBy) => {
			return dispatch(SearchApprovedClients(search, page, pageSize, order, orderBy));
		},
		getClientInfo: (id) => dispatch(GetClientInfo(id)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(ApprovedClients);
